import { FlashScreenDesktop } from '../../../components/FlashScreen/FlashScreen';
import AchievementCongratulationsPage from '../../Achievements/components/AchievementCongratulationsPage';
import { Modal } from 'react-bootstrap';
import useCloseLocation from '../../Location/hooks/useCloseLocation';
import { LOCATION_COMPONENTS_SEARCH_PARAMS, LOCATION_NAMES } from '../../Location/locationConstants';

function AchievementModal() {
    const handleClose = useCloseLocation({
        locationName: LOCATION_NAMES.ACHIEVEMENT,
        typeLocation: LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL,
    });

    return <Modal show
                  onHide={handleClose}
                  centered
                  size={'lg'}
    >
        <FlashScreenDesktop handleClose={handleClose}>
            <AchievementCongratulationsPage/>
        </FlashScreenDesktop>
    </Modal>;
}

export default AchievementModal;
